import { cn } from '@/lib/utils';
import { cardShape, boxShape } from '@/lib/shapeStyles';

/**
 * Container Surface System
 * Solid containers for page content, glass only for modals/overlays
 */

// Solid base styling (shared across page containers)
const solidBase = cn(
	'border border-white/[0.08]',
	'shadow-[inset_0_1px_1px_rgba(255,255,255,0.03)]'
);

// Glass base styling (for modals, trays, overlays only)
const glassBase = cn(
	'backdrop-blur-md',
	'border border-white/[0.08]',
	'shadow-[inset_0_1px_1px_rgba(255,255,255,0.03)]'
);

// Chrome level (header, profile strips, toolbars, sidebars) - #101116
export const chromeContainer = cn('bg-chrome', solidBase, boxShape);

// Content level (cards, panels on page) - #101116
export const contentContainer = cn('bg-chrome', solidBase, boxShape);
export const contentCard = cn('bg-chrome', solidBase, cardShape);

// Glass containers (ONLY for modals, sheets, overlays)
export const glassModalContainer = cn('bg-black/20', glassBase, boxShape);
export const glassModalCard = cn('bg-black/20', glassBase, cardShape);

// Legacy aliases for migration
export const headerMatchContainer = chromeContainer;
export const cardContainer = contentCard;
export const panelBackground = cn('bg-chrome');
export const glassContainer = glassModalContainer; // Only use in modals!
export const glassCard = glassModalCard; // Only use in modals!

// Elevated content boxes (stats, info boxes)
export const elevatedBox = cn(contentContainer, 'p-2');

// Subtle info containers
export const infoContainer = contentCard;

// Container with hover effect
export const glassContainerHover = cn(
	contentContainer,
	'hover:bg-[hsl(220,10%,10%)] hover:border-white/[0.12]',
	'transition-colors duration-200'
);

// Divider
export const glassDivider = 'border-white/[0.05]';
